import { render, staticRenderFns } from "./MainText.vue?vue&type=template&id=0725fb78&"
import script from "./MainText.vue?vue&type=script&lang=js&"
export * from "./MainText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports